<template>
  <div class="mt-5 text-center p">
    <h2 class="text-center text-uppercase" id="prod-spec">
      Product specificaties
    </h2>
    <ul class="nav nav-tabs bg-light" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link widthFixTab active desc"
          id="home-tab"
          data-bs-toggle="tab"
          data-bs-target="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >
          Beschrijving
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link widthFixTab extra-info"
          id="profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >
          Extra informatie
        </a>
      </li>
    </ul>

    <div class="tab-content" id="myTabContent">
      <!-- product summary -->
      <div
        class="tab-pane fade show active m-3"
        id="home"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <h3 v-if="product.naam !== product.kleur" class="text-start mb-3">
          {{ product.naam }} {{ product.kleur }}
        </h3>
        <h3 v-else class="text-start mb-3">{{ product.naam }}</h3>
        <p class="text-start">{{ product.productbeschrijving }}</p>
      </div>
      <!-- product specifications -->
      <div
        class="tab-pane fade"
        id="profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <div class="productDetails justify-content-between mt-0">
          <template v-for="(propertie, key) in specification" :key="key">
            <div class="d-flex productDetailOption">
              <p
                class="col-2 p-0 m-0 py-1 text-start fw-bold"
                :id="'info-' + key"
              >
                id=info-{{ key }}
              </p>
              <p class="col-10 p-0 m-0 text-start">
                {{ propertie }}
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductInformation",
  props: {
    product: Object,
  },
  data() {
    return {
      exclude: [
        "index",
        "naam",
        "korteProductbeschrijving",
        "assortiment",
        "amount",
        "afbeelding",
        "afbeeldingMeerdere",
        "productbeschrijving",
        "korteProductbeschrijving",
        "kleurFilter",
        "selectedRol",
        "productCode",
      ],
      hasUnit: [
        "rolBreedte",
        "hoogte",
        "lengte",
        "breedte",
        "dikte",
        "slijtLaag",
      ],
      specification: {},
    };
  },
  methods: {
    buildInformation(product) {
      if (product !== undefined && product !== "") {
        for (const propertie in product) {
          if (
            !this.exclude.includes(propertie) &&
            product[propertie] !== "" &&
            product[propertie] !== undefined &&
            !propertie.endsWith("Eenheid")
          ) {
            if (typeof product[propertie] === "object") {
              for (const index in product[propertie]) {
                if (
                  product[propertie][index] !== undefined &&
                  product[propertie][index] !== "" &&
                  product[propertie][index] !== null
                ) {
                  // if propertie is in hasUnit array get unit value and add
                  if (this.hasUnit.includes(propertie)) {
                    let unit = propertie + "Eenheid";

                    if (index == 0) {
                      this.specification[propertie] =
                        product[propertie][index] + " " + product[unit];
                    } else {
                      this.specification[propertie] +=
                        ", " + product[propertie][index] + " " + product[unit];
                    }
                  } else {
                    if (index == 0) {
                      this.specification[propertie] = product[propertie][index];
                    } else {
                      this.specification[propertie] +=
                        ", " + product[propertie][index];
                    }
                  }
                }
                // end propertie value loop
              }
            }
            // propertie is not an object
            else {
              if (this.hasUnit.includes(propertie)) {
                let unit = propertie + "Eenheid";
                this.specification[propertie] =
                  product[propertie] + " " + product[unit];
              } else {
                this.specification[propertie] = product[propertie];
              }
            }
          }
        }
      }

      // end build info
    },
    // end methods
  },
  created() {
    this.buildInformation(this.product);
  },
  beforeUpdate() {
    this.buildInformation(this.product);
  },
  updated() {
    this.$store.commit("storeLocUpdate", true);
  },
};
</script>

<style scoped></style>
